import { createActions, createReducer } from 'reduxsauce';

export const { Types, Creators } = createActions({
  // #region [PATCH] cadastro-inativos/lista-inativos/{id}/atualizar-status
  putListaInativosAtualizarStatusRequest: ['idLista', 'idStatus'],
  putListaInativosAtualizarStatusResponse: ['success', 'error'],
  // #endregion
});

// #region [PATCH] cadastro-inativos/lista-inativos/{id}/atualizar-status
const putListaInativosAtualizarStatus = {
  success: false,
  error: null,
  loading: false,
};
// #endregion

const INICIAL_STATE = {
  putListaInativosAtualizarStatus,
};

// #region [PATCH] cadastro-inativos/lista-inativos/{id}/atualizar-status
const putListaInativosAtualizarStatusRequest = (state = INICIAL_STATE) => ({
  ...state,
  putListaInativosAtualizarStatus: {
    ...state.putListaInativosAtualizarStatus,

    success: false,
    error: null,
    loading: false,
  },
});

const putListaInativosAtualizarStatusResponse = (
  state = INICIAL_STATE,
  action
) => ({
  ...state,
  putListaInativosAtualizarStatus: {
    ...state.putListaInativosAtualizarStatus,

    success: action.success,
    error: action.error,
    loading: false,
  },
});
// #endregion

export default createReducer(INICIAL_STATE, {
  [Types.PUT_LISTA_INATIVOS_ATUALIZAR_STATUS_REQUEST]: putListaInativosAtualizarStatusRequest,
  [Types.PUT_LISTA_INATIVOS_ATUALIZAR_STATUS_RESPONSE]: putListaInativosAtualizarStatusResponse,
});
